
<script>
	import listBase from '@_system/components/base/list.vue'
	export default {
		extends: listBase,
		name: 'collectioncustomerIndex',
		props: {

		},
		data() {
			return {
				moduleName: 'collectioncustomer',
				windowName: '自动财审客户',
				windowType: 'modal',
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {

		},
		components: {
			
		}
	}
</script>
